export var CONFIG = {
  SYS_MODULE: [
    'TraceModule',
    'DidiBridgeAdapter'
  ]
};


// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/fusion/src/config/config.js